import { FaUmbrellaBeach as FeriadosIcon } from 'react-icons/fa'

import { Feriado, PermissaoTipo } from '@core/models/entities'
import { useAuth, useFetch } from '@presentation/hooks'
import { TablePage } from '@presentation/components/templates'
import { PageProps } from '@presentation/types/components/templates'
import {
  Filter,
  FilterProps,
  TableColumn,
  TableProps
} from '@presentation/types/components/organisms'

import {
  AddFeriadoModal,
  DeleteFeriadoModal,
  EditFeriadoModal,
  ReactivateFeriadoModal
} from './components'

const FeriadosPage: React.FC = () => {
  const { hasPermission } = useAuth()
  const { data, isFetching, totalItems, fetchData } = useFetch({
    path: '/feriados',
    options: { sortBy: 'nome' },
    queries: {
      status: 1
    }
  })

  const pageConfigs: PageProps = {
    icon: <FeriadosIcon />,
    title: 'Feriados',
    description: 'Página de gerenciamento de feriados do campus.',
    actions: hasPermission(PermissaoTipo.Escrita)
      ? [<AddFeriadoModal onAdd={fetchData} />]
      : []
  }

  const filters: Filter[] = [
    {
      type: {
        value: 'data',
        label: 'Data'
      },
      description: {
        type: 'input',
        configs: {
          type: 'date'
        }
      }
    },
    {
      type: {
        value: 'nome',
        label: 'Nome'
      },
      description: {
        type: 'input',
        configs: {
          type: 'text'
        }
      }
    },
    {
      type: {
        value: 'tipo',
        label: 'Tipo'
      },
      description: {
        type: 'select-api',
        configs: {
          type: '/feriados',
          isMulti: true
        }
      }
    }
  ]

  const filterConfigs: FilterProps = {
    filters,
    fetchData,
    defaultQueries: {
      status: 1
    },
    hasStatus: true
  }
  const columns: Array<TableColumn<Feriado>> = [
    {
      name: 'Data',
      selector: feriado => '',
      center: true
    },

    {
      name: 'Nome',
      selector: feriado => feriado.nome,
      center: true
    },
    {
      name: 'Tipo',
      selector: feriado => feriado.feriado_tipo.descricao,
      center: true
    },
    {
      name: 'Ações',
      cell: feriado => (
        <>
          {feriado.status ? (
            <>
              {hasPermission(PermissaoTipo.Escrita) && (
                <EditFeriadoModal id={feriado.id} onEdit={fetchData} />
              )}
              {hasPermission(PermissaoTipo.Remocao) && (
                <DeleteFeriadoModal id={feriado.id} onDelete={fetchData} />
              )}
            </>
          ) : (
            <>
              {hasPermission(PermissaoTipo.Escrita) && (
                <ReactivateFeriadoModal
                  id={feriado.id}
                  onReactivate={fetchData}
                />
              )}
            </>
          )}
        </>
      ),
      center: true
    }
  ]

  const tableConfigs: TableProps = {
    columns,
    data,
    apiConfigs: {
      totalItems,
      fetchData,
      isFetching
    }
  }

  return (
    <TablePage
      pageConfigs={pageConfigs}
      filterConfigs={filterConfigs}
      tableConfigs={tableConfigs}
    />
  )
}

export default FeriadosPage
